import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { _ as _ts_values } from "@swc/helpers/_/_ts_values";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col, Modal, Button, Form, Image } from "react-bootstrap";
import { Stack, Switch } from "@mui/material";
import Select from "react-select";
import { Formik } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { nanoid } from "nanoid";
import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import moment from "moment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CircleIcon from "@mui/icons-material/Circle";
import { ModalAllder } from "layouts/ModalAllder";
import DataTableLayout from "layouts/DatatableLayout";
import DataSyncControl from "layouts/DataSyncControl";
import { syncProduct } from "../../redux/handlers/syncdata/syncProduct.handler";
import EditIcon from "@mui/icons-material/Edit";
import { getPrefixName, filterTextAndNum } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { datalistProduct } from "../../redux/handlers/product/datalistProduct.handler";
import { getAllChannelOffline } from "../../redux/handlers/product/getAllChannelOffline.handler";
import { getAllChannelOnline } from "../../redux/handlers/product/getAllChannelOnline.handler";
import { getAllMstUnit } from "../../redux/handlers/product/getAllMstUnit.handler";
import { getEvidenceType } from "../../redux/handlers/product/getEvidenceType.handler";
import { getProductType } from "../../redux/handlers/product/getProductType.handler";
import { getCategory } from "../../redux/handlers/product/getCategory.handler";
import { getSubCategory } from "../../redux/handlers/product/getSubCategory.handler";
import { getAllMstUnitWeight } from "../../redux/handlers/product/getAllMstUnitWeight.handler";
import { getAllDimension } from "../../redux/handlers/product/getAllDimension.handler";
import { getAllProductFileType } from "../../redux/handlers/product/getAllProductFileType.handler";
import { getProductDetail } from "../../redux/handlers/product/getProductDetail.handler";
import { uploadProduct } from "../../redux/handlers/product/uploadProduct.handler";
import { clearUpdateProduct, updateProduct } from "../../redux/handlers/product/updateProduct.handler";
import { getAllMstBusiness } from "../../redux/handlers/master/getAllMstBusiness.handler";
import { getAllMstBrand } from "../../redux/handlers/master/getAllMstBrand.handler";
import { updateStatusContinue } from "../../redux/handlers/product/updateStatusContinue.handler";
import { appendDeletedProductDetail } from "../../utils/productDetailRows";
var hasInputValue = function(value) {
    return value !== null && value !== undefined && value !== "";
};
var toNumberOrZero = function(value) {
    return hasInputValue(value) ? parseFloat(value) : 0;
};
var toIntOrZero = function(value) {
    return hasInputValue(value) ? parseInt(value, 10) : 0;
};
var calculateDetailGp = function(priceValue, recommentPriceValue) {
    var price = toNumberOrZero(priceValue);
    var recommentPrice = toNumberOrZero(recommentPriceValue);
    if (recommentPrice <= 0) {
        return 0;
    }
    return parseFloat(((recommentPrice - price) / recommentPrice * 100).toFixed(2));
};
var calculateProductGp = function(priceValue, recommentPriceValue) {
    var price = toNumberOrZero(priceValue);
    var recommentPrice = toNumberOrZero(recommentPriceValue);
    if (price <= 0) {
        return 0;
    }
    return parseFloat(((recommentPrice - price) / price * 100).toFixed(2));
};
export function ProductList() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), filteredItems = _useState1[0], setFilteredItems = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), row = _useState2[0], setRow = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), Businessid = _useState4[0], setBusinessid = _useState4[1];
    var _useState5 = _sliced_to_array(useState(null), 2), Brandid = _useState5[0], setBrandid = _useState5[1];
    var _useState6 = _sliced_to_array(useState(null), 2), Statusid = _useState6[0], setStatusid = _useState6[1];
    var _useState7 = _sliced_to_array(useState(null), 2), Continueid = _useState7[0], setContinueid = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), optionBus = _useState8[0], setOptionBus = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), optionBrand = _useState9[0], setOptionBrand = _useState9[1];
    var _useState10 = _sliced_to_array(useState([
        {
            value: null,
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "แบบร่าง"
        },
        {
            value: 2,
            label: "รออนุมัติ"
        },
        {
            value: 3,
            label: "อนุมัติ"
        },
        {
            value: 4,
            label: "ไม่อนุมัติ"
        },
        {
            value: 5,
            label: "รอแก้ไข"
        }
    ]), 2), optionStatus = _useState10[0], setOptionStatus = _useState10[1];
    var optionContinue = [
        {
            value: null,
            label: "ทั้งหมด"
        },
        {
            value: 1,
            label: "Continue"
        },
        {
            value: 2,
            label: "ไม่ Continue"
        }
    ];
    var _useState11 = _sliced_to_array(useState(false), 2), modalsuccess = _useState11[0], setModalsuccess = _useState11[1];
    var _useState12 = _sliced_to_array(useState(false), 2), textsuccess = _useState12[0], setTextsuccess = _useState12[1];
    var _useState13 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 550,
        height: 400,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalContinue = _useState13[0], setModalContinue = _useState13[1];
    var datalistProductReducer = useAppSelector(function(state) {
        return state.datalistProductReducer;
    });
    var getAllMstBusinessReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessReducer;
    });
    var getAllMstBrandReducer = useAppSelector(function(state) {
        return state.getAllMstBrandReducer;
    });
    useEffect(function() {
        dispatch(getAllMstBusiness());
        dispatch(getAllMstBrand());
    }, []);
    useEffect(function() {
        dispatch(datalistProduct({
            brand: Brandid,
            status: Statusid,
            continueStatus: Continueid,
            productname: filterText,
            businessid: parseInt(Businessid)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(datalistProductReducer.isFetching || getAllMstBusinessReducer.isFetching || getAllMstBrandReducer.isFetching);
        if (datalistProductReducer.data) {
            var data = datalistProductReducer.data.data;
            setFilteredItems(data);
            setRow(data);
            setRowData(data);
        }
        if (getAllMstBusinessReducer.data) {
            var arr = [
                {
                    value: null,
                    label: "ทั้งหมด"
                }
            ];
            getAllMstBusinessReducer.data.data.map(function(ele) {
                return arr.push({
                    value: ele.bus_business_id,
                    label: ele.bus_business_businesstype == 1 ? getPrefixName(ele.bus_business_prefixid) + filterTextAndNum(ele.bus_business_fname) + " " + filterTextAndNum(ele.bus_business_lname) : ele.bus_business_businesstype == 2 ? filterTextAndNum(ele.bus_business_comprefixname) + " " + filterTextAndNum(ele.bus_business_name) + " " + filterTextAndNum(ele.bus_business_suffixname) : filterTextAndNum(ele.bus_business_name)
                });
            });
            setOptionBus(arr);
        }
        if (getAllMstBrandReducer.data && !getAllMstBrandReducer.isError) {
            var dataBrandNew = [
                {
                    value: null,
                    label: "ทั้งหมด"
                }
            ];
            getAllMstBrandReducer.data.data.map(function(ele) {
                return dataBrandNew.push({
                    label: ele.set_brand_name,
                    value: ele.set_brand_id
                });
            });
            setOptionBrand(dataBrandNew);
        }
    }, [
        datalistProductReducer,
        getAllMstBusinessReducer,
        getAllMstBrandReducer
    ]);
    var columns = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.pd_product_code;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/productlist/edit/" + row.pd_product_id + "/view",
                        children: row.pd_product_code ? row.pd_product_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "Barcode",
            width: "150px",
            selector: function(row) {
                return row.pd_product_barcode;
            },
            cell: function(row, index, column, id) {
                return row.pd_product_barcode ? row.pd_product_barcode : /*#__PURE__*/ _jsx("span", {
                    className: "ml-10",
                    children: "-"
                });
            }
        },
        {
            name: "ชื่อแบรนด์",
            selector: function(row) {
                return row.pd_product_brandid;
            },
            maxWidth: "160px",
            cell: function(row, index, column, id) {
                var _row_SetBrand;
                return row.SetBrand ? (_row_SetBrand = row.SetBrand) === null || _row_SetBrand === void 0 ? void 0 : _row_SetBrand.set_brand_name : /*#__PURE__*/ _jsx("span", {
                    className: "ml-10",
                    children: "-"
                });
            }
        },
        {
            name: "ชื่อสินค้า",
            selector: function(row) {
                return row.pd_product_nameth;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: row.pd_product_nameen || ""
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                color: "#000"
                            },
                            children: row.pd_product_nameth || ""
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                color: "#6c757d"
                            },
                            children: row.pd_product_namela || ""
                        })
                    ]
                });
            }
        },
        {
            name: "ชื่อธุรกิจ",
            selector: function(row) {
                var bus = row.BusBusiness;
                if (!bus) return "-";
                return bus.bus_business_businesstype == 2 ? "".concat(bus.bus_business_comprefixname || "", " ").concat(bus.bus_business_name, " ").concat(bus.bus_business_suffixname || "") : bus.bus_business_businesstype == 1 ? "".concat(getPrefixName(bus.bus_business_prefixid)).concat(bus.bus_business_fname, " ").concat(bus.bus_business_lname || "") : bus.bus_business_name;
            }
        },
        {
            name: "Continue",
            selector: function(row) {
                return row.pd_product_continue;
            },
            center: "true",
            width: "120px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Switch, {
                    checked: row.pd_product_continue == 1,
                    onClick: function() {
                        setModalContinue(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true,
                                data: {
                                    id: row.pd_product_id,
                                    nameth: row.pd_product_nameth,
                                    nameen: row.pd_product_nameen,
                                    status: row.pd_product_continue
                                }
                            });
                        });
                    }
                });
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.status;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return row.pd_product_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#797A7A",
                        backgroundColor: "#E9E9E9",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "แบบร่าง"
                }) || row.pd_product_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รออนุมัติ"
                }) || row.pd_product_status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FFFFFF",
                        backgroundColor: "#10B02A",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "อนุมัติ"
                }) || row.pd_product_status == 4 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่อนุมัติ"
                }) || row.pd_product_status == 5 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6f42c1",
                        backgroundColor: "#e2d9f3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รอแก้ไข"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.pd_product_id;
            },
            center: "true",
            width: "120px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/productlist/edit/" + row.pd_product_id,
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        Number(row.pd_product_status) === 3 && /*#__PURE__*/ _jsx(DataSyncControl, {
                            syncStatus: row.pd_product_syncstatus,
                            rowData: row,
                            syncHandler: syncProduct,
                            syncPayload: function(data) {
                                return {
                                    productid: data.pd_product_id
                                };
                            },
                            syncHandlerOptions: {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            },
                            onSyncSuccess: function() {
                                return dispatch(datalistProduct({
                                    brand: Brandid,
                                    status: Statusid,
                                    continueStatus: Continueid,
                                    productname: filterText,
                                    businessid: parseInt(Businessid)
                                }, {
                                    modalObj: modalObj,
                                    setModalObj: setModalObj
                                }));
                            }
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsx("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7  text-decoration-none",
                                    children: "จัดการสินค้า"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: "จัดการสินค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลือกค้นหาจากแบรนด์"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-1",
                                                    placeholder: "เลือกค้นหาจากแบรนด์",
                                                    options: optionBrand,
                                                    value: optionBrand.find(function(opt) {
                                                        return opt.value === Brandid;
                                                    }) || optionBrand[0] || null,
                                                    onChange: function(e) {
                                                        setBrandid(e.value);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลือกค้นหาจากสถานะ"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-1",
                                                    placeholder: "เลือกค้นหาจากสถานะ",
                                                    options: optionStatus,
                                                    value: optionStatus.find(function(opt) {
                                                        return opt.value === Statusid;
                                                    }) || optionStatus[0] || null,
                                                    onChange: function(e) {
                                                        setStatusid(e.value);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลือกค้นหาจากธุรกิจ"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-1",
                                                    placeholder: "เลือกค้นหาจากธุรกิจ",
                                                    options: optionBus,
                                                    value: optionBus.find(function(opt) {
                                                        return opt.value === Businessid;
                                                    }) || optionBus[0] || null,
                                                    onChange: function(e) {
                                                        setBusinessid(e.value);
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "Continue"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    className: "w-100 select-st-1",
                                                    options: optionContinue,
                                                    value: optionContinue.find(function(opt) {
                                                        return opt.value === Continueid;
                                                    }) || optionContinue[0],
                                                    onChange: function(option) {
                                                        var _option_value;
                                                        return setContinueid((_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : null);
                                                    },
                                                    isClearable: false
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: 3,
                                        xl: 3,
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "horizontal",
                                            children: /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                className: "form-control form-st-3 py-2",
                                                placeholder: "ค้นหา...",
                                                onChange: function(e) {
                                                    return setFilterText(e.target.value);
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 1,
                                        className: "d-flex justify-content-end",
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "horizontal",
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                className: "btn-st-7 my-2 w-100",
                                                onClick: function() {
                                                    return dispatch(datalistProduct({
                                                        brand: Brandid,
                                                        status: Statusid,
                                                        continueStatus: Continueid,
                                                        productname: filterText,
                                                        businessid: parseInt(Businessid)
                                                    }, {
                                                        modalObj: modalObj,
                                                        setModalObj: setModalObj
                                                    }));
                                                },
                                                variant: "",
                                                children: "ค้นหา"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalContinue,
                setModal: setModalContinue,
                htitle: "Continue",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ContinueModal, {
                    setModal: setModalContinue,
                    modal: modalContinue,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    Brandid: Brandid,
                    Statusid: Statusid,
                    Continueid: Continueid,
                    filterText: filterText,
                    Businessid: Businessid
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function ProductUpdate() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var businessID = null;
    var memID = null;
    var _useState = _sliced_to_array(useState(false), 2), modalcancel = _useState[0], setModalcancel = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), modalsuccess = _useState1[0], setModalsuccess = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), textsuccess = _useState2[0], setTextsuccess = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), formdisabled = _useState3[0], setFormdisabled = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), loadRow = _useState4[0], setLoadRow = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), optionsOffline = _useState5[0], setOptionsOffline = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), optionsOnline = _useState6[0], setOptionsOnline = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionsUnit = _useState7[0], setOptionsUnit = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), evidenceType = _useState8[0], setEvidenceType = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), optionsType = _useState9[0], setOptionsType = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), optionsCate = _useState10[0], setOptionsCate = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), optionsSupCate = _useState11[0], setOptionsSupCate = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), optionsUnitWeight = _useState12[0], setOptionsUnitWeight = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), optionsDimension = _useState13[0], setOptionsDimension = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), optionsMstBrand = _useState14[0], setOptionsMstBrand = _useState14[1];
    var _useState15 = _sliced_to_array(useState([]), 2), valOffline = _useState15[0], setValOffline = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), valOnline = _useState16[0], setValOnline = _useState16[1];
    var _useState17 = _sliced_to_array(useState([]), 2), valComment = _useState17[0], setValComment = _useState17[1];
    var _useState18 = _sliced_to_array(useState(null), 2), brandId = _useState18[0], setBrandId = _useState18[1];
    var _useState19 = _sliced_to_array(useState([]), 2), optionsProductFile = _useState19[0], setOptionsProductFile = _useState19[1];
    var _useState20 = _sliced_to_array(useState(""), 2), comment = _useState20[0], setComment = _useState20[1];
    var _useState21 = _sliced_to_array(useState(""), 2), imgPath = _useState21[0], setImgPath = _useState21[1];
    var _useState22 = _sliced_to_array(useState(""), 2), docPath = _useState22[0], setDocPath = _useState22[1];
    var _useState23 = _sliced_to_array(useState([]), 2), galleryPath = _useState23[0], setGalleryPath = _useState23[1];
    var _useState24 = _sliced_to_array(useState([]), 2), galleryDel = _useState24[0], setGalleryDel = _useState24[1];
    var _useState25 = _sliced_to_array(useState(""), 2), pdDate = _useState25[0], setPdDate = _useState25[1];
    var _useState26 = _sliced_to_array(useState([
        {
            id: nanoid(),
            pd_pdetail_barcode: "",
            pd_pdetail_unitid: "",
            pd_pdetail_ratio: null,
            pd_pdetail_continer: null,
            pd_pdetail_price: null,
            pd_pdetail_recommentprice: null,
            pd_pdetail_gp: null,
            pd_pdetail_weight: null,
            pd_pdetail_unitweightid: "",
            pd_pdetail_wide: null,
            pd_pdetail_long: null,
            pd_pdetail_high: null,
            pd_pdetail_dimensionid: ""
        }
    ]), 2), productRow = _useState26[0], setProductRow = _useState26[1];
    var _useState27 = _sliced_to_array(useState([]), 2), productRowDel = _useState27[0], setProductRowDel = _useState27[1];
    var _useState28 = _sliced_to_array(useState({
        pd_product_businessid: businessID,
        pd_product_nameth: "",
        pd_product_nameen: "",
        pd_product_namela: "",
        pd_product_channelother: "",
        pd_product_producttypeid: "",
        pd_product_categoryid: "",
        pd_product_categorysubid: "",
        pd_product_brand: "",
        pd_product_detail: "",
        pd_product_vat: 7,
        pd_product_evidencenumber: ""
    }), 2), formData = _useState28[0], setFormData = _useState28[1];
    useEffect(function() {
        loadAllMsts();
    }, []);
    var loadAllMsts = function() {
        dispatch(getAllChannelOffline());
        dispatch(getAllChannelOnline());
        dispatch(getAllMstUnit());
        dispatch(getEvidenceType());
        dispatch(getProductType());
        dispatch(getAllMstUnitWeight());
        dispatch(getAllDimension());
        dispatch(getAllProductFileType());
        dispatch(getAllMstBrand());
        if (dataID) {
            dispatch(getProductDetail(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            setImgPath("");
        }
    };
    var getAllChannelOfflineReducer = useAppSelector(function(state) {
        return state.getAllChannelOfflineReducer;
    });
    var getAllChannelOnlineReducer = useAppSelector(function(state) {
        return state.getAllChannelOnlineReducer;
    });
    var getAllMstUnitReducer = useAppSelector(function(state) {
        return state.getAllMstUnitReducer;
    });
    var getEvidenceTypeReducer = useAppSelector(function(state) {
        return state.getEvidenceTypeReducer;
    });
    var getProductTypeReducer = useAppSelector(function(state) {
        return state.getProductTypeReducer;
    });
    var getCategoryReducer = useAppSelector(function(state) {
        return state.getCategoryReducer;
    });
    var getSubCategoryReducer = useAppSelector(function(state) {
        return state.getSubCategoryReducer;
    });
    var getAllMstUnitWeightReducer = useAppSelector(function(state) {
        return state.getAllMstUnitWeightReducer;
    });
    var getAllDimensionReducer = useAppSelector(function(state) {
        return state.getAllDimensionReducer;
    });
    var getAllMstBrandReducer = useAppSelector(function(state) {
        return state.getAllMstBrandReducer;
    });
    var getProductDetailReducer = useAppSelector(function(state) {
        return state.getProductDetailReducer;
    });
    var getAllProductFileTypeReducer = useAppSelector(function(state) {
        return state.getAllProductFileTypeReducer;
    });
    var updateProductReducer = useAppSelector(function(state) {
        return state.updateProductReducer;
    });
    useEffect(function() {
        setIsLoading(updateProductReducer.isFetching);
        if (updateProductReducer.data && !updateProductReducer.isError) {
            setTextsuccess("แก้ไขสินค้าสำเร็จ");
            dispatch(clearUpdateProduct());
            setModalsuccess(true);
            setFormdisabled(true);
            navigate("/productlist");
        }
    }, [
        updateProductReducer
    ]);
    useEffect(function() {
        if (dataID) {
            setIsLoading(getProductDetailReducer.isFetching);
            if (getProductDetailReducer.data) {
                setFormData(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        // pd_product_barcode:
                        //   getProductDetailReducer.data.data[0].pd_product_barcode,
                        pd_product_brand: getProductDetailReducer.data.data[0].pd_product_brand != "null" ? getProductDetailReducer.data.data[0].pd_product_brand : "",
                        pd_product_brandid: getProductDetailReducer.data.data[0].pd_product_brandid,
                        pd_product_businessid: getProductDetailReducer.data.data[0].pd_product_businessid,
                        pd_product_categoryid: getProductDetailReducer.data.data[0].pd_product_categoryid,
                        pd_product_categorysubid: getProductDetailReducer.data.data[0].pd_product_categorysubid,
                        pd_product_channelother: getProductDetailReducer.data.data[0].pd_product_channelother != "null" ? getProductDetailReducer.data.data[0].pd_product_channelother : "",
                        pd_product_code: getProductDetailReducer.data.data[0].pd_product_code,
                        // pd_product_dayexpire:
                        //   getProductDetailReducer.data.data[0].pd_product_dayexpire,
                        // pd_product_pddate: getProductDetailReducer.data.data[0]
                        //   .pd_product_pddate
                        //   ? moment(
                        //       getProductDetailReducer.data.data[0].pd_product_pddate
                        //     ).format("DD/MM/YYYY")
                        //   : "",
                        pd_product_detail: getProductDetailReducer.data.data[0].pd_product_detail != "null" ? getProductDetailReducer.data.data[0].pd_product_detail : "",
                        pd_product_dimensionid: //   getProductDetailReducer.data.data[0].pd_product_dimensionid,
                        // pd_product_evidence:
                        getProductDetailReducer.data.data[0].pd_product_evidence,
                        pd_product_evidencenumber: getProductDetailReducer.data.data[0].pd_product_evidencenumber,
                        // pd_product_evidencetypeid:
                        //   getProductDetailReducer.data.data[0].pd_product_evidencetypeid,
                        // pd_product_gp: getProductDetailReducer.data.data[0].pd_product_gp,
                        pd_product_high: getProductDetailReducer.data.data[0].pd_product_high,
                        pd_product_id: getProductDetailReducer.data.data[0].pd_product_id,
                        pd_product_long: getProductDetailReducer.data.data[0].pd_product_long,
                        pd_product_nameen: getProductDetailReducer.data.data[0].pd_product_nameen,
                        pd_product_namela: getProductDetailReducer.data.data[0].pd_product_namela,
                        pd_product_nameth: getProductDetailReducer.data.data[0].pd_product_nameth,
                        // pd_product_price:
                        //   getProductDetailReducer.data.data[0].pd_product_price,
                        pd_product_producttypeid: getProductDetailReducer.data.data[0].pd_product_producttypeid,
                        // pd_product_recommentprice:
                        //   getProductDetailReducer.data.data[0].pd_product_recommentprice,
                        pd_product_unitid: getProductDetailReducer.data.data[0].pd_product_unitid,
                        pd_product_unitweightid: getProductDetailReducer.data.data[0].pd_product_unitweightid,
                        pd_product_vat: getProductDetailReducer.data.data[0].pd_product_vat,
                        pd_product_weight: getProductDetailReducer.data.data[0].pd_product_weight,
                        pd_product_wide: getProductDetailReducer.data.data[0].pd_product_wide,
                        pd_product_status: getProductDetailReducer.data.data[0].pd_product_status
                    });
                });
                var detail = [];
                if (getProductDetailReducer.data.data[0].PdPdetail) {
                    getProductDetailReducer.data.data[0].PdPdetail.map(function(ele) {
                        return detail.push(_object_spread_props(_object_spread({}, ele), {
                            id: nanoid(),
                            pd_pdetail_dimensionid: ele.pd_pdetail_dimensionid == 0 ? "" : ele.pd_pdetail_dimensionid,
                            pd_pdetail_high: ele.pd_pdetail_high == 0 ? "" : ele.pd_pdetail_high,
                            pd_pdetail_long: ele.pd_pdetail_long == 0 ? "" : ele.pd_pdetail_long,
                            pd_pdetail_unitweightid: ele.pd_pdetail_unitweightid == 0 ? "" : ele.pd_pdetail_unitweightid,
                            pd_pdetail_wide: ele.pd_pdetail_wide == 0 ? "" : ele.pd_pdetail_wide,
                            pd_pdetail_weight: ele.pd_pdetail_weight == 0 ? "" : ele.pd_pdetail_weight,
                            type: "update"
                        }));
                    });
                }
                detail.sort(function(a, b) {
                    return Number(a.pd_pdetail_id) - Number(b.pd_pdetail_id);
                });
                setProductRow(detail);
                dispatch(getCategory(getProductDetailReducer.data.data[0].pd_product_producttypeid));
                dispatch(getSubCategory(getProductDetailReducer.data.data[0].pd_product_producttypeid, getProductDetailReducer.data.data[0].pd_product_categoryid));
                var offline = [];
                getProductDetailReducer.data.data[0].PdPchanneloffline.map(function(ele) {
                    return offline.push(_object_spread_props(_object_spread({}, ele), {
                        type: "update"
                    }));
                });
                setValOffline(offline);
                var online = [];
                getProductDetailReducer.data.data[0].PdPchannelonline.map(function(ele) {
                    return online.push(_object_spread_props(_object_spread({}, ele), {
                        type: "update"
                    }));
                });
                setValComment(getProductDetailReducer.data.data[0].PdPcomment);
                setValOnline(online);
                setImgPath(getProductDetailReducer.data.data[0].pd_product_image);
                setPdDate(new Date(getProductDetailReducer.data.data[0].pd_product_pddate));
                var pImg = [];
                getProductDetailReducer.data.data[0].PdPimage.map(function(ele) {
                    return pImg.push({
                        id: nanoid(),
                        pd_pimage_id: ele.pd_pimage_id,
                        pd_pimage_name: ele.pd_pimage_name,
                        type: "update"
                    });
                });
                setGalleryPath(pImg);
                var pFile = [];
                getProductDetailReducer.data.data[0].PdPfile.map(function(ele) {
                    return pFile.push({
                        id: nanoid(),
                        pd_pfile_id: ele.pd_pfile_id,
                        pd_pfile_name: ele.pd_pfile_name,
                        pd_pfile_typeid: ele.pd_pfile_typeid,
                        type: "update"
                    });
                });
                setDocuments(pFile);
            }
        }
    }, [
        getProductDetailReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllChannelOfflineReducer.isFetching || getAllChannelOnlineReducer.isFetching || getAllMstUnitReducer.isFetching || getProductTypeReducer.isFetching || getCategoryReducer.isFetching || getSubCategoryReducer.isFetching || getAllMstUnitWeightReducer.isFetching || getAllDimensionReducer.isFetching || getAllMstBrandReducer.isFetching || getAllProductFileTypeReducer.isFetching);
        if (getAllChannelOfflineReducer.data) {
            var dataOffline = [];
            getAllChannelOfflineReducer.data.data.map(function(ele) {
                return dataOffline.push({
                    label: ele.set_channeloffline_name,
                    value: ele.set_channeloffline_id
                });
            });
            setOptionsOffline(dataOffline);
        }
        if (getAllChannelOnlineReducer.data) {
            var dataOnline = [];
            getAllChannelOnlineReducer.data.data.map(function(ele) {
                return dataOnline.push({
                    label: ele.set_channelonline_name,
                    value: ele.set_channelonline_id
                });
            });
            setOptionsOnline(dataOnline);
        }
        if (getAllMstUnitReducer.data) {
            var dataUnit = [];
            getAllMstUnitReducer.data.data.map(function(ele) {
                return dataUnit.push({
                    label: ele.set_unit_name,
                    value: ele.set_unit_id
                });
            });
            setOptionsUnit(dataUnit);
        }
        if (getEvidenceTypeReducer.data) {
            var dataEvidence = [];
            getEvidenceTypeReducer.data.data.map(function(ele) {
                return dataEvidence.push({
                    label: ele.set_evidencetype_name,
                    value: ele.set_evidencetype_id
                });
            });
            setEvidenceType(dataEvidence);
        }
        if (getProductTypeReducer.data) {
            var dataProduct = [];
            getProductTypeReducer.data.data.map(function(ele) {
                return dataProduct.push({
                    label: ele.set_producttype_name + " (" + ele.set_producttype_nameen + ")",
                    value: ele.set_producttype_id
                });
            });
            setOptionsType(dataProduct);
        }
        if (getCategoryReducer.data) {
            var dataCate = [];
            getCategoryReducer.data.data.map(function(ele) {
                return dataCate.push({
                    label: ele.set_productcategory_name + " (" + ele.set_productcategory_nameen + ")",
                    value: ele.set_productcategory_id
                });
            });
            setOptionsCate(dataCate);
        }
        if (getSubCategoryReducer.data) {
            var dataSubCate = [];
            getSubCategoryReducer.data.data.map(function(ele) {
                return dataSubCate.push({
                    label: ele.set_productcategorysub_name + " (" + ele.set_productcategorysub_nameen + ")",
                    value: ele.set_productcategorysub_id
                });
            });
            setOptionsSupCate(dataSubCate);
        }
        if (getAllMstUnitWeightReducer.data) {
            var dataUnitWeight = [];
            getAllMstUnitWeightReducer.data.data.map(function(ele) {
                return dataUnitWeight.push({
                    label: ele.set_unitweight_name,
                    value: ele.set_unitweight_id
                });
            });
            setOptionsUnitWeight(dataUnitWeight);
        }
        if (getAllDimensionReducer.data) {
            var dataDimension = [];
            getAllDimensionReducer.data.data.map(function(ele) {
                return dataDimension.push({
                    label: ele.set_dimension_name,
                    value: ele.set_dimension_id
                });
            });
            setOptionsDimension(dataDimension);
        }
        if (getAllMstBrandReducer.data && !getAllMstBrandReducer.isError) {
            var dataBrandNew = [];
            getAllMstBrandReducer.data.data.map(function(ele) {
                return dataBrandNew.push({
                    label: ele.set_brand_name + " (" + ele.set_brand_nameen + ")",
                    value: ele.set_brand_id
                });
            });
            setOptionsMstBrand(dataBrandNew);
        }
        if (getAllProductFileTypeReducer.data) {
            var dataProductFile = [];
            getAllProductFileTypeReducer.data.data.map(function(ele) {
                return dataProductFile.push({
                    label: ele.set_productfiletype_name,
                    value: ele.set_productfiletype_id
                });
            });
            setOptionsProductFile(dataProductFile);
        }
    }, [
        getAllChannelOfflineReducer,
        getAllChannelOnlineReducer,
        getAllMstUnitReducer,
        getEvidenceTypeReducer,
        getProductTypeReducer,
        getCategoryReducer,
        getSubCategoryReducer,
        getAllMstUnitWeightReducer,
        getAllDimensionReducer,
        getAllMstBrandReducer,
        getAllProductFileTypeReducer
    ]);
    var addProductRow = function() {
        var _ref = _async_to_generator(function(num) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadRow(false);
                        productRow.push({
                            id: nanoid(),
                            pd_pdetail_barcode: "",
                            pd_pdetail_unitid: "",
                            pd_pdetail_ratio: null,
                            pd_pdetail_continer: null,
                            pd_pdetail_price: null,
                            pd_pdetail_recommentprice: null,
                            pd_pdetail_gp: null,
                            pd_pdetail_weight: null,
                            pd_pdetail_unitweightid: "",
                            pd_pdetail_wide: null,
                            pd_pdetail_long: null,
                            pd_pdetail_high: null,
                            pd_pdetail_dimensionid: "",
                            type: "create"
                        });
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            setLoadRow(true)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function addProductRow(num) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeOption = function(action, event, item) {
        if (action == "offline") {
            var offline = [];
            event.map(function(ele) {
                if (dataID) {
                    var find = item.find(function(v) {
                        return v.pd_pchanneloffline_channelofflineid == ele.value;
                    });
                    offline.push({
                        pd_pchanneloffline_channelofflineid: ele.value,
                        pd_pchanneloffline_name: ele.label,
                        pd_pchanneloffline_businessid: businessID,
                        pd_pchanneloffline_id: find ? find.pd_pchanneloffline_id : "",
                        pd_pchanneloffline_productid: parseInt(dataID),
                        type: find ? "update" : "create"
                    });
                } else {
                    offline.push({
                        pd_pchanneloffline_channelofflineid: ele.value,
                        pd_pchanneloffline_name: ele.label
                    });
                }
            });
            setValOffline(offline);
        }
        if (action == "online") {
            var online = [];
            event.map(function(ele) {
                if (dataID) {
                    var find = item.find(function(v) {
                        return v.pd_pchannelonline_channelonlineid == ele.value;
                    });
                    online.push({
                        pd_pchannelonline_channelonlineid: ele.value,
                        pd_pchannelonline_name: ele.label,
                        pd_pchannelonline_businessid: businessID,
                        pd_pchannelonline_id: find ? find.pd_pchannelonline_id : "",
                        pd_pchannelonline_productid: parseInt(dataID),
                        type: find ? "update" : "create"
                    });
                } else {
                    online.push({
                        pd_pchannelonline_channelonlineid: ele.value,
                        pd_pchannelonline_name: ele.label
                    });
                }
            });
            setValOnline(online);
        }
    };
    var onDeleteProduct = function(removeId, item) {
        setProductRow(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        setProductRowDel(function(deletedRows) {
            return appendDeletedProductDetail(deletedRows, item);
        });
    };
    var _useState29 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState29[0], setModalSuccess = _useState29[1];
    var _useState30 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState30[0], setModalAlert = _useState30[1];
    var _useState31 = _sliced_to_array(useState([
        {
            id: nanoid(),
            pd_pfile_typeid: null,
            pd_pfile_name: null,
            type: "create"
        }
    ]), 2), documents = _useState31[0], setDocuments = _useState31[1];
    var _useState32 = _sliced_to_array(useState([]), 2), documentsDel = _useState32[0], setDocumentsDel = _useState32[1];
    var addDocument = function(num) {
        // <-- not Button -->
        // for (var i = 0; i < num; i++) {
        setDocuments(function(row) {
            return _to_consumable_array(row).concat([
                {
                    id: nanoid(),
                    pd_pfile_typeid: null,
                    pd_pfile_name: null,
                    type: "create"
                }
            ]);
        });
    };
    var deleteDocument = function(removeId, item) {
        setDocuments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                pd_pfile_id: item.pd_pfile_id
            };
            setDocumentsDel(_to_consumable_array(documentsDel).concat([
                del
            ]));
        }
    };
    var optionsVAt = [
        {
            label: "ไม่มี",
            value: 0
        },
        {
            label: "VAT 3%",
            value: 3
        },
        {
            label: "VAT 7%",
            value: 7
        },
        {
            label: "VAT 10%",
            value: 10
        }
    ];
    var disable = param.view == "view" ? true : false;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0 mb-1",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "/product",
                                className: "tc-7  text-decoration-none",
                                children: "จัดการสินค้า"
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: dataID ? "แก้ไขสินค้า" : "สร้างสินค้า"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formData,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                    if (!values.pd_product_nameth || !values.pd_product_nameen == null || !productRow[0].pd_pdetail_barcode || !productRow[0].pd_pdetail_unitid || !hasInputValue(productRow[0].pd_pdetail_recommentprice) || !hasInputValue(productRow[0].pd_pdetail_price) || !pdDate || !imgPath) {
                        setModalAlert(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true
                            });
                        });
                        return false;
                    } else if (dataID) {
                        var _loop = function(key) {
                            if (Object.hasOwnProperty.call(values, key) && key !== "pd_product_status") {
                                var value = values[key];
                                if (Array.isArray(value)) {
                                    value.forEach(function(item) {
                                        return formdataPayload.append(key, item);
                                    });
                                } else if (value !== undefined) {
                                    formdataPayload.append(key, value);
                                }
                            }
                        };
                        var createProductRow = [];
                        productRow.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return createProductRow.push({
                                pd_pdetail_barcode: ele.pd_pdetail_barcode,
                                pd_pdetail_ratio: toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_continer: "1x" + toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_price: toNumberOrZero(ele.pd_pdetail_price),
                                pd_pdetail_recommentprice: toNumberOrZero(ele.pd_pdetail_recommentprice),
                                pd_pdetail_gp: calculateDetailGp(ele.pd_pdetail_price, ele.pd_pdetail_recommentprice),
                                pd_pdetail_weight: ele.pd_pdetail_weight ? parseFloat(ele.pd_pdetail_weight) : 0,
                                pd_pdetail_unitid: ele.pd_pdetail_unitid ? ele.pd_pdetail_unitid : 0,
                                pd_pdetail_unitweightid: ele.pd_pdetail_unitweightid ? ele.pd_pdetail_unitweightid : 0,
                                pd_pdetail_wide: ele.pd_pdetail_wide ? parseFloat(ele.pd_pdetail_wide) : 0,
                                pd_pdetail_high: ele.pd_pdetail_high ? parseFloat(ele.pd_pdetail_high) : 0,
                                pd_pdetail_long: ele.pd_pdetail_long ? parseFloat(ele.pd_pdetail_long) : 0,
                                pd_pdetail_dimensionid: ele.pd_pdetail_dimensionid ? ele.pd_pdetail_dimensionid : 0
                            });
                        });
                        var updateProductRow = [];
                        productRow.filter(function(v) {
                            return v.type == "update";
                        }).map(function(ele) {
                            return updateProductRow.push({
                                pd_pdetail_id: ele.pd_pdetail_id,
                                pd_pdetail_barcode: ele.pd_pdetail_barcode,
                                pd_pdetail_ratio: toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_continer: "1x" + toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_price: toNumberOrZero(ele.pd_pdetail_price),
                                pd_pdetail_recommentprice: toNumberOrZero(ele.pd_pdetail_recommentprice),
                                pd_pdetail_gp: calculateDetailGp(ele.pd_pdetail_price, ele.pd_pdetail_recommentprice),
                                pd_pdetail_weight: ele.pd_pdetail_weight ? parseFloat(ele.pd_pdetail_weight) : 0,
                                pd_pdetail_unitid: ele.pd_pdetail_unitid ? ele.pd_pdetail_unitid : 0,
                                pd_pdetail_unitweightid: ele.pd_pdetail_unitweightid ? ele.pd_pdetail_unitweightid : 0,
                                pd_pdetail_wide: ele.pd_pdetail_wide ? parseFloat(ele.pd_pdetail_wide) : 0,
                                pd_pdetail_high: ele.pd_pdetail_high ? parseFloat(ele.pd_pdetail_high) : 0,
                                pd_pdetail_long: ele.pd_pdetail_long ? parseFloat(ele.pd_pdetail_long) : 0,
                                pd_pdetail_dimensionid: ele.pd_pdetail_dimensionid ? ele.pd_pdetail_dimensionid : 0
                            });
                        });
                        var updateOffline = [];
                        valOffline// .filter((v) => v.type == "update")
                        .map(function(ele) {
                            return updateOffline.push({
                                pd_pchanneloffline_channelofflineid: ele.pd_pchanneloffline_channelofflineid,
                                pd_pchanneloffline_name: ele.pd_pchanneloffline_name
                            });
                        });
                        var updateOnline = [];
                        valOnline// .filter((v) => v.type == "update")
                        .map(function(ele) {
                            return updateOnline.push({
                                pd_pchannelonline_channelonlineid: ele.pd_pchannelonline_channelonlineid,
                                pd_pchannelonline_name: ele.pd_pchannelonline_name
                            });
                        });
                        var galleryCreate = [];
                        galleryPath.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return galleryCreate.push({
                                pd_pimage_name: ele.pd_pimage_name
                            });
                        });
                        var galleryUpdate = [];
                        galleryPath.filter(function(v) {
                            return v.type == "update";
                        }).map(function(ele) {
                            return galleryUpdate.push({
                                pd_pimage_name: ele.pd_pimage_name,
                                pd_pimage_id: ele.pd_pimage_id
                            });
                        });
                        for(var key in values)_loop(key);
                        formdataPayload.append("pddetailcreate", JSON.stringify(createProductRow));
                        formdataPayload.append("pddetailupdate", JSON.stringify(updateProductRow));
                        formdataPayload.append("pddetaildelete", JSON.stringify(productRowDel));
                        formdataPayload.append("offlineupdate", JSON.stringify(updateOffline));
                        formdataPayload.append("onlineupdate", JSON.stringify(updateOnline));
                        formdataPayload.append("pd_product_image", imgPath);
                        // formdataPayload.append("pd_product_evidencefile", docPath);
                        formdataPayload.append("imagecreate", JSON.stringify(galleryCreate));
                        formdataPayload.append("imageupdate", JSON.stringify(galleryUpdate));
                        formdataPayload.append("imagedelete", JSON.stringify(galleryDel));
                        formdataPayload.append("pd_product_pddate", pdDate ? moment(pdDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "");
                        formdataPayload.append("pd_product_price", JSON.stringify(toNumberOrZero(productRow[0].pd_pdetail_price)));
                        formdataPayload.append("pd_product_barcode", productRow[0].pd_pdetail_barcode);
                        formdataPayload.append("pd_product_recommentprice", JSON.stringify(toNumberOrZero(productRow[0].pd_pdetail_recommentprice)));
                        formdataPayload.append("pd_product_gp", JSON.stringify(calculateProductGp(productRow[0].pd_pdetail_price, productRow[0].pd_pdetail_recommentprice)));
                        var docCreate = [];
                        documents.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return docCreate.push({
                                pd_pfile_businessid: businessID,
                                pd_pfile_name: ele.pd_pfile_name,
                                pd_pfile_typeid: ele.pd_pfile_typeid
                            });
                        });
                        formdataPayload.append("filecreate", JSON.stringify(docCreate));
                        var docUpdate = [];
                        documents.filter(function(v) {
                            return v.type == "update";
                        }).map(function(ele) {
                            return docUpdate.push({
                                pd_pfile_businessid: businessID,
                                pd_pfile_id: ele.pd_pfile_id,
                                pd_pfile_name: ele.pd_pfile_name,
                                pd_pfile_typeid: ele.pd_pfile_typeid
                            });
                        });
                        formdataPayload.append("fileupdate", JSON.stringify(docUpdate));
                        formdataPayload.append("filedelete", JSON.stringify(documentsDel));
                        dispatch(updateProduct(formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param1) {
                    var handleSubmit = param1.handleSubmit, handleChange = param1.handleChange, touched = param1.touched, errors = param1.errors, values = param1.values, setFieldValue = param1.setFieldValue, isInvalid = param1.isInvalid, isValid = param1.isValid;
                    var _productRow_, _productRow_1, _productRow_2, _productRow_3, _productRow_4, _productRow_5, _productRow_6, _productRow_7, _productRow_8;
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(Form, {
                                noValidate: true,
                                onSubmit: function(e) {
                                    e.preventDefault();
                                    handleSubmit();
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("fieldset", {
                                        disabled: formdisabled,
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "ข้อมูลทั่วไป"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "รหัสสินค้า",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: "*"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_code",
                                                                                    className: "form-control",
                                                                                    placeholder: "รหัสสินค้า",
                                                                                    value: values.pd_product_code,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_code: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "Barcode",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: " *"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_barcode",
                                                                                    className: "form-control",
                                                                                    placeholder: "barcode",
                                                                                    value: (_productRow_ = productRow[0]) === null || _productRow_ === void 0 ? void 0 : _productRow_.pd_pdetail_barcode,
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "ชื่อสินค้าภาษาไทย ( TH )",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: " *"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_nameth",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกชื่อสินค้าภาษาไทย ( TH )",
                                                                                    value: values.pd_product_nameth,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_nameth: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    isInvalid: !!errors.pd_product_nameth,
                                                                                    disabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "ชื่อสินค้าภาษาอังกฤษ",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: " *"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_nameen",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกชื่อสินค้าภาษาอังกฤษ",
                                                                                    value: values.pd_product_nameen,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_nameen: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    isInvalid: !!errors.pd_product_nameen,
                                                                                    disabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ชื่อสินค้าภาษาลาว"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_namela",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกชื่อสินค้าภาษาลาว",
                                                                                    value: values.pd_product_namela || "",
                                                                                    onChange: function(e) {
                                                                                        handleChange(e);
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_namela: e.target.value
                                                                                        }));
                                                                                    },
                                                                                    disabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-3 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ช่องทางจำหน่ายออฟไลน์"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                    className: "w-100 select-st-1 select-multi",
                                                                                    name: "pchanneloffline_id",
                                                                                    as: "select",
                                                                                    isMulti: true,
                                                                                    options: optionsOffline,
                                                                                    onChange: function(e) {
                                                                                        handleChangeOption("offline", e, valOffline);
                                                                                    },
                                                                                    placeholder: "เลือกช่องทางจำหน่ายออฟไลน์",
                                                                                    value: optionsOffline.filter(function(opt) {
                                                                                        return valOffline.some(function(v) {
                                                                                            return v.pd_pchanneloffline_channelofflineid === opt.value;
                                                                                        });
                                                                                    }),
                                                                                    isDisabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-3 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ช่องทางจำหน่ายออนไลน์"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                    className: "w-100 select-st-1 select-multi",
                                                                                    name: "pchannelonline_id",
                                                                                    as: "select",
                                                                                    isMulti: true,
                                                                                    options: optionsOnline,
                                                                                    onChange: function(e) {
                                                                                        handleChangeOption("online", e, valOnline);
                                                                                    },
                                                                                    placeholder: "เลือกช่องทางจำหน่ายออนไลน์",
                                                                                    value: optionsOnline.filter(function(opt) {
                                                                                        return valOnline.some(function(v) {
                                                                                            return v.pd_pchannelonline_channelonlineid === opt.value;
                                                                                        });
                                                                                    }),
                                                                                    // isClearable={(e) => aaaaaaa(e)}
                                                                                    // {value.some((v) => !v.isFixed)}
                                                                                    isDisabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-3 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ช่องทางจำหน่ายอื่นๆ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_channelother",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกช่องทางจำหน่ายอื่นๆ",
                                                                                    value: values.pd_product_channelother,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_channelother: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "วันหมดอายุ",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: " *"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "pr-[15px]",
                                                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                        inputFormat: "DD/MM/YYYY",
                                                                                        dateFormat: "dd/MM/yyyy",
                                                                                        placeholderText: "วันหมดอายุ",
                                                                                        selected: pdDate,
                                                                                        onChange: function(date) {
                                                                                            setPdDate(date);
                                                                                        },
                                                                                        placeholder: "DD/MM/YYYY",
                                                                                        className: "w-100 datepicker2",
                                                                                        value: pdDate,
                                                                                        disabled: disable
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "อายุสินค้า ( วัน )"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_dayexpire",
                                                                                    disabled: true,
                                                                                    className: "form-control",
                                                                                    placeholder: "อายุสินค้า ( วัน )",
                                                                                    // value={dayjs(pdDate, new Date())}
                                                                                    value: pdDate ? dayjs(moment(pdDate).format("YYYY-MM-DD")).diff(dayjs(moment(new Date()).format("YYYY-MM-DD")), "day") > 0 ? dayjs(moment(pdDate).format("YYYY-MM-DD")).diff(dayjs(moment(new Date()).format("YYYY-MM-DD")), "day") : "หมดอายุ" : ""
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "ข้อมูลสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "form-st-3 sm pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ประเภทสินค้า"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_product_producttypeid",
                                                                                        className: "w-100 select-st-1",
                                                                                        placeholder: "เลือกประเภทสินค้า",
                                                                                        options: optionsType,
                                                                                        value: optionsType.filter(function(item) {
                                                                                            return item.value === values.pd_product_producttypeid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_producttypeid: e.value,
                                                                                                pd_product_categoryid: "",
                                                                                                pd_product_categorysubid: ""
                                                                                            })); // Update formData state
                                                                                            dispatch(getCategory(e.value));
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "form-st-3 sm pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "หมวดหมู่หลัก"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_product_categoryid",
                                                                                        className: "w-100 select-st-1",
                                                                                        placeholder: "เลือกหมวดหมู่หลัก",
                                                                                        options: optionsCate,
                                                                                        value: optionsCate.filter(function(item) {
                                                                                            return item.value === values.pd_product_categoryid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_categoryid: e.value,
                                                                                                pd_product_categorysubid: ""
                                                                                            })); // Update formData state
                                                                                            dispatch(getSubCategory(formData.pd_product_producttypeid, e.value));
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "form-st-3 sm pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "หมวดหมู่ย่อย"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_product_categorysubid",
                                                                                        className: "w-100 select-st-1",
                                                                                        placeholder: "เลือกหมวดหมู่ย่อย",
                                                                                        options: optionsSupCate,
                                                                                        value: optionsSupCate.filter(function(item) {
                                                                                            return item.value === values.pd_product_categorysubid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_categorysubid: e.value
                                                                                            })); // Update formData state
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ยี่ห้อ (แบรนด์)"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_product_brand",
                                                                                        placeholder: "ยี่ห้อ (แบรนด์)",
                                                                                        value: values.pd_product_brand,
                                                                                        onChange: function(e) {
                                                                                            handleChange(e); // Update Formik's state
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_brand: e.target.value
                                                                                            })); // Update formData state
                                                                                        },
                                                                                        disabled: disable
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ยี่ห้อ (แบรนด์ สำหรับแอดมิน)"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_product_brandid",
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_brandid: e.value
                                                                                            })); // Update formData state
                                                                                        },
                                                                                        // onChange={(e) => {
                                                                                        //   setFieldValue("pd_product_brandid", e.value);
                                                                                        //   setBrandId(e.value);
                                                                                        // }}
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsMstBrand,
                                                                                        placeholder: "เลือกยี่ห้อ (แบรนด์ สำหรับแอดมิน)",
                                                                                        value: optionsMstBrand.filter(function(item) {
                                                                                            return item.value === values.pd_product_brandid;
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "รายละเอียดสินค้า"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    as: "textarea",
                                                                                    rows: 3,
                                                                                    name: "pd_product_detail",
                                                                                    disabled: disable,
                                                                                    value: values.pd_product_detail,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_detail: e.target.value
                                                                                        })); // Update formData state
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "กำหนดราคานำเสนอ"
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "pt-3 px-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-3 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "form-st-3 sm pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "อัตราภาษีขาย",
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                className: "text-danger ms-1",
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_product_vat",
                                                                                        className: "w-100 select-st-1",
                                                                                        placeholder: "เลือกอัตราภาษีขาย",
                                                                                        options: optionsVAt,
                                                                                        value: optionsVAt.filter(function(item) {
                                                                                            return item.value === values.pd_product_vat;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_vat: e.value
                                                                                            })); // Update formData state
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                productRow.map(function(item, i) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-2",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-2 col-md-2",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "Barcode",
                                                                                                i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "text-danger ms-1",
                                                                                                    children: "*"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_barcode",
                                                                                            className: "form-control",
                                                                                            placeholder: "กรอก Barcode",
                                                                                            value: item === null || item === void 0 ? void 0 : item.pd_pdetail_barcode,
                                                                                            disabled: disable,
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_barcode: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "form-st-3 sm pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: [
                                                                                                    "หน่วย",
                                                                                                    i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                        className: "text-danger ms-1",
                                                                                                        children: "*"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                                as: "select",
                                                                                                name: "pd_pdetail_unitid",
                                                                                                className: "w-100 select-st-1",
                                                                                                options: optionsUnit,
                                                                                                placeholder: "เลือกหน่วย",
                                                                                                value: optionsUnit.filter(function(d) {
                                                                                                    return d.value == (item === null || item === void 0 ? void 0 : item.pd_pdetail_unitid);
                                                                                                }),
                                                                                                onChange: function(e) {
                                                                                                    setProductRow(function(prev) {
                                                                                                        return prev.map(function(el) {
                                                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                                pd_pdetail_unitid: e.value
                                                                                                            }) : el;
                                                                                                        });
                                                                                                    });
                                                                                                },
                                                                                                isDisabled: disable
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "อัตราส่วน(ชิ้น)",
                                                                                                i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "text-danger ms-1",
                                                                                                    children: "*"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_ratio",
                                                                                            className: "form-control",
                                                                                            placeholder: "อัตราส่วน",
                                                                                            value: item === null || item === void 0 ? void 0 : item.pd_pdetail_ratio,
                                                                                            disabled: disable,
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_ratio: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "Container"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_continer",
                                                                                            className: "form-control",
                                                                                            placeholder: "Container",
                                                                                            value: (item === null || item === void 0 ? void 0 : item.pd_pdetail_ratio) ? "1x" + (item === null || item === void 0 ? void 0 : item.pd_pdetail_ratio) : "1x",
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_ratio: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            disabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "ราคานำเสนอ",
                                                                                                i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "text-danger ms-1",
                                                                                                    children: "*"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_price",
                                                                                            className: "form-control",
                                                                                            placeholder: "ราคานำเสนอ",
                                                                                            value: item === null || item === void 0 ? void 0 : item.pd_pdetail_price,
                                                                                            style: {
                                                                                                background: "#E4F5FF"
                                                                                            },
                                                                                            disabled: disable,
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_price: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "ราคาแนะนำขาย",
                                                                                                i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "text-danger ms-1",
                                                                                                    children: "*"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_recommentprice",
                                                                                            className: "form-control",
                                                                                            placeholder: "ราคาแนะนำขาย",
                                                                                            disabled: disable,
                                                                                            value: item === null || item === void 0 ? void 0 : item.pd_pdetail_recommentprice,
                                                                                            style: {
                                                                                                background: "#2DC76D24"
                                                                                            },
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_recommentprice: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-1 col-md-3",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "GP"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_gp",
                                                                                            className: "form-control",
                                                                                            placeholder: "GP",
                                                                                            value: hasInputValue(item === null || item === void 0 ? void 0 : item.pd_pdetail_price) && hasInputValue(item === null || item === void 0 ? void 0 : item.pd_pdetail_recommentprice) ? calculateDetailGp(item === null || item === void 0 ? void 0 : item.pd_pdetail_price, item === null || item === void 0 ? void 0 : item.pd_pdetail_recommentprice).toFixed(2) : 0,
                                                                                            disabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-1 col-md-1",
                                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                    className: "mb-2 mt-4 ml-3 form-st-3 pb-1",
                                                                                    children: i != 0 && /*#__PURE__*/ _jsx("button", {
                                                                                        type: "button",
                                                                                        className: "btn btn-delete-file ",
                                                                                        disabled: disable,
                                                                                        onClick: function(e) {
                                                                                            return onDeleteProduct(item.id, item);
                                                                                        }
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, i);
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsx(Button, {
                                                                                type: "button",
                                                                                className: "btn-st-3 me-3",
                                                                                onClick: function() {
                                                                                    return addProductRow(1);
                                                                                },
                                                                                disabled: disable,
                                                                                children: "เพิ่มราคาและอัตราส่วน"
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "ข้อมูลเฉพาะสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: productRow.map(function(item, i) {
                                                                return /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-4 col-md-10",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "Barcode",
                                                                                            i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                className: "text-danger ms-1",
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_barcode",
                                                                                        className: "form-control",
                                                                                        placeholder: "กรอก Barcode",
                                                                                        value: item === null || item === void 0 ? void 0 : item.pd_pdetail_barcode,
                                                                                        disabled: true,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_barcode: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-2",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "หน่วย",
                                                                                            i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                className: "text-danger ms-1",
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_pdetail_unitid",
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsUnit,
                                                                                        placeholder: "เลือกหน่วย",
                                                                                        value: optionsUnit.filter(function(d) {
                                                                                            return d.value == (item === null || item === void 0 ? void 0 : item.pd_pdetail_unitid);
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_unitid: e.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        isDisabled: true
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-4 col-md-10",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "น้ำหนักสินค้า"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_weight",
                                                                                        className: "form-control",
                                                                                        placeholder: "น้ำหนักสินค้า",
                                                                                        value: item === null || item === void 0 ? void 0 : item.pd_pdetail_weight,
                                                                                        disabled: disable,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_weight: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-2",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "หน่วยน้ำหนัก"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_pdetail_unitweightid",
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsUnitWeight,
                                                                                        placeholder: "เลือกหน่วยน้ำหนัก",
                                                                                        value: optionsUnitWeight.filter(function(d) {
                                                                                            return d.value == (item === null || item === void 0 ? void 0 : item.pd_pdetail_unitweightid);
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_unitweightid: e.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ความกว้าง"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_wide",
                                                                                        className: "form-control",
                                                                                        placeholder: "ความกว้าง",
                                                                                        value: item === null || item === void 0 ? void 0 : item.pd_pdetail_wide,
                                                                                        disabled: disable,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_wide: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ความยาว"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_long",
                                                                                        className: "form-control",
                                                                                        placeholder: "ความยาว",
                                                                                        value: item === null || item === void 0 ? void 0 : item.pd_pdetail_long,
                                                                                        disabled: disable,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_long: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ความสูง"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_high",
                                                                                        className: "form-control",
                                                                                        placeholder: "ความสูง",
                                                                                        value: item === null || item === void 0 ? void 0 : item.pd_pdetail_high,
                                                                                        disabled: disable,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_high: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "หน่วย Dimension"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_pdetail_dimensionid",
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsDimension,
                                                                                        placeholder: "Dimension",
                                                                                        value: optionsDimension.filter(function(d) {
                                                                                            return d.value == (item === null || item === void 0 ? void 0 : item.pd_pdetail_dimensionid);
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_dimensionid: e.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("hr", {
                                                                            className: "my-2",
                                                                            style: {
                                                                                opacity: 0.1
                                                                            }
                                                                        })
                                                                    ]
                                                                }, i);
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "เอกสารมาตราฐานการผลิต"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "row gx-xl-4",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-md-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เลขที่ใบอนุญาต"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "pd_product_evidencenumber",
                                                                                placeholder: "เลขที่ใบอนุญาต",
                                                                                value: values.pd_product_evidencenumber,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        pd_product_evidencenumber: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                // isInvalid={!!errors.pd_product_evidencenumber}
                                                                                disabled: disable
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        documents.map(function(item, index) {
                                                            return /*#__PURE__*/ _jsx(EvidenceDoc, {
                                                                setFieldValue: setFieldValue,
                                                                values: values,
                                                                item: item,
                                                                index: index,
                                                                setDocuments: setDocuments,
                                                                modalObj: modalObj,
                                                                setModalObj: setModalObj,
                                                                evidenceType: evidenceType,
                                                                setIsLoading: setIsLoading,
                                                                optionsProductFile: optionsProductFile,
                                                                disabled: disable,
                                                                ondeleteDocument: function(id) {
                                                                    deleteDocument(id, item);
                                                                }
                                                            }, index);
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "px-3 py-4",
                                                            children: /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn btn-st-4",
                                                                onClick: addDocument,
                                                                disabled: disable,
                                                                children: "เพิ่มเอกสาร"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "รูปภาพสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "pt-3 px-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-3",
                                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                                className: "fs-16 px-3",
                                                                                children: [
                                                                                    "ภาพสินค้ามาตราฐาน",
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "text-danger ms-1",
                                                                                        children: "*"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-3",
                                                                            children: /*#__PURE__*/ _jsx(ImageProductUpload, {
                                                                                isUpdate: dataID != undefined,
                                                                                setFieldValue: setFieldValue,
                                                                                setFormData: setFormData,
                                                                                setImgPath: setImgPath,
                                                                                imgPath: imgPath,
                                                                                setIsLoading: setIsLoading,
                                                                                setModalObj: setModalObj,
                                                                                modalObj: modalObj,
                                                                                values: values,
                                                                                view: param.view
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-8 col-md-6"
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "offset-xl-2 col-xl-4 offset-md-3 col-md-4",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "pr-1",
                                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                                style: {
                                                                                                    fontSize: 5
                                                                                                }
                                                                                            })
                                                                                        }),
                                                                                        "อัปโหลดรูปภาพพื้นหลังขาวเท่านั้น"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "pr-1",
                                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                                style: {
                                                                                                    fontSize: 5
                                                                                                }
                                                                                            })
                                                                                        }),
                                                                                        "อัปโหลดรูปภาพขนาดไฟล์ไม่เกิน 2 MB"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "pr-1",
                                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                                style: {
                                                                                                    fontSize: 5
                                                                                                }
                                                                                            })
                                                                                        }),
                                                                                        "อัปโหลดรูปภาพขนาดภาพไม่เกิน 1000x1000"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "pr-1",
                                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                                style: {
                                                                                                    fontSize: 5
                                                                                                }
                                                                                            })
                                                                                        }),
                                                                                        "รูปสินค้าจะแสดงผลหน้าผลการค้นหา และหน้าสินค้าแนะนำ"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4 mt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-3",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                className: "fs-16 px-3",
                                                                                children: "แกลลอรี่"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-10 col-md-9",
                                                                            children: /*#__PURE__*/ _jsx(ImageGalleryUpload, {
                                                                                isUpdate: dataID != undefined,
                                                                                setFieldValue: setFieldValue,
                                                                                values: values,
                                                                                view: param.view,
                                                                                galleryPath: galleryPath,
                                                                                setGalleryPath: setGalleryPath,
                                                                                galleryDel: galleryDel,
                                                                                setGalleryDel: setGalleryDel,
                                                                                setIsLoading: setIsLoading,
                                                                                setModalObj: setModalObj,
                                                                                modalObj: modalObj
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "row gx-xl-4 mt-3",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "offset-xl-2 col-xl-4 offset-md-3 col-md-5",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "fs-12",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "pr-1",
                                                                                        children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                            style: {
                                                                                                fontSize: 5
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    "อัปโหลดรูปภาพขนาดไฟล์ไม่เกิน 2 MB"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "fs-12",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "pr-1",
                                                                                        children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                            style: {
                                                                                                fontSize: 5
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    "อัปโหลดรูปภาพขนาดภาพไม่เกิน 1000x1000"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "fs-12",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "pr-1",
                                                                                        children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                            style: {
                                                                                                fontSize: 5
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    "รูปสินค้าจะแสดงผลหน้าผลการค้นหา และหน้าสินค้าแนะนำ"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8 fs-18 fw-bold px-4",
                                                            children: "คำแนะนำในการกรอกข้อมูล"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fs-16 px-3 mb-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "pr-2",
                                                                                    children: ((_productRow_1 = productRow[0]) === null || _productRow_1 === void 0 ? void 0 : _productRow_1.pd_pdetail_barcode) ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                        style: {
                                                                                            color: "#2DC76D"
                                                                                        }
                                                                                    }) : /*#__PURE__*/ _jsx(ErrorIcon, {
                                                                                        style: {
                                                                                            color: "#FF0000"
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                "Barcode หลัก"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fs-16 px-3 mb-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "pr-2",
                                                                                    children: formData.pd_product_nameth && formData.pd_product_nameen ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                        style: {
                                                                                            color: "#2DC76D"
                                                                                        }
                                                                                    }) : /*#__PURE__*/ _jsx(ErrorIcon, {
                                                                                        style: {
                                                                                            color: "#FF0000"
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                "ชื่อสินค้าภาษาไทย / ภาษาอังกฤษ"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fs-16 px-3 mb-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "pr-2",
                                                                                    children: hasInputValue((_productRow_2 = productRow[0]) === null || _productRow_2 === void 0 ? void 0 : _productRow_2.pd_pdetail_price) && hasInputValue((_productRow_3 = productRow[0]) === null || _productRow_3 === void 0 ? void 0 : _productRow_3.pd_pdetail_recommentprice) ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                        style: {
                                                                                            color: "#2DC76D"
                                                                                        }
                                                                                    }) : /*#__PURE__*/ _jsx(ErrorIcon, {
                                                                                        style: {
                                                                                            color: "#FF0000"
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                "ราคานำเสนอหลัก / ราคาแนะนำขายหลัก / อัตราภาษีขาย"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fs-16 px-3 mb-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "pr-2",
                                                                                    children: imgPath ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                        style: {
                                                                                            color: "#2DC76D"
                                                                                        }
                                                                                    }) : /*#__PURE__*/ _jsx(ErrorIcon, {
                                                                                        style: {
                                                                                            color: "#FF0000"
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                "เพิ่มรูปสินค้ามาตราฐาน"
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "text-end btn-group-control",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        className: "btn-st-6 me-3 btn",
                                                        href: "/productlist",
                                                        children: "ยกเลิก"
                                                    }),
                                                    param.view != "view" && /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        onClick: function() {
                                                            handleSubmit();
                                                        },
                                                        className: "btn btn-dg",
                                                        children: "บันทึก"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(ModalAllder, {
                                modal: modalAlert,
                                setModal: setModalAlert,
                                htitle: "แจ้งเตือน",
                                hbtn: false,
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text-center pt-4 tc-5",
                                        style: {
                                            fontSize: "22px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !values.pd_product_nameth && "- กรอกชื่อสินค้าภาษาไทย ( TH )"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !values.pd_product_nameen && "- กรอกชื่อสินค้าภาษาอังกฤษ ( EN )"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !((_productRow_4 = productRow[0]) === null || _productRow_4 === void 0 ? void 0 : _productRow_4.pd_pdetail_barcode) && "- กรอก Barcode สินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !((_productRow_5 = productRow[0]) === null || _productRow_5 === void 0 ? void 0 : _productRow_5.pd_pdetail_unitid) && "- เลือกหน่วยสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !((_productRow_6 = productRow[0]) === null || _productRow_6 === void 0 ? void 0 : _productRow_6.pd_pdetail_ratio) && "- กรอกอัตราส่วนสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !hasInputValue((_productRow_7 = productRow[0]) === null || _productRow_7 === void 0 ? void 0 : _productRow_7.pd_pdetail_price) && "- กรอกราคานำเสนอสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !hasInputValue((_productRow_8 = productRow[0]) === null || _productRow_8 === void 0 ? void 0 : _productRow_8.pd_pdetail_recommentprice) && "- กรอกราคาแนะนำขายสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !pdDate && "- เลือกวันหมดอายุ"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !imgPath && "- ภาพสินค้ามาตราฐาน"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "d-flex align-items-center pb-4 pt-5 ",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn-st-3 mx-auto",
                                            onClick: function() {
                                                return setModalAlert(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        open: false
                                                    });
                                                });
                                            },
                                            children: "ยืนยัน"
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            }),
            valComment.length > 0 && dataID && /*#__PURE__*/ _jsx("div", {
                className: "card card-st-3 mb-3",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card-body px-10",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "pt-3 px-3",
                        children: valComment.map(function(ele, i) {
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "row gx-xl-2 mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-1 col-md-1 text-end",
                                        children: ele.pd_pcomment_by == 1 && /*#__PURE__*/ _jsx(Stack, {
                                            direction: "row",
                                            justifyContent: "flex-end",
                                            spacing: 3,
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/Avatar.png",
                                                roundedCircle: true,
                                                style: {
                                                    width: 50,
                                                    border: "4px solid #107BEF",
                                                    borderRadius: 30
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-10 col-md-10",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-st-1 mx-3 p-3",
                                            style: {
                                                background: "#F6E1E3"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsxs(Stack, {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    spacing: 3,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fw-500",
                                                            children: ele.pd_pcomment_by == 1 && "SYSTEM" || ele.pd_pcomment_by == 2 && "PARTNER" || ele.pd_pcomment_by == 3 && "ADMIN"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-12",
                                                            children: moment(ele.pd_pcomment_issuedate).format("DD/MM/YYYY HH:mm")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: ele.pd_pcomment_detail
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-1 col-md-1",
                                        children: ele.pd_pcomment_by == 2 || ele.pd_pcomment_by == 3 && /*#__PURE__*/ _jsx(Image, {
                                            src: "/images/Avatar.png",
                                            roundedCircle: true,
                                            style: {
                                                width: 50,
                                                border: "4px solid #107BEF",
                                                borderRadius: 30
                                            }
                                        })
                                    })
                                ]
                            }, i);
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ConfirmCancelModal, {
                show: modalcancel,
                onHide: function() {
                    return setModalcancel(false);
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate,
                direction: dataID ? null : "/product"
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            })
        ]
    });
}
function ConfirmCancelModal(props) {
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "md",
        centered: true,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "px-3 py-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-22 tc-7 mb-2",
                                    children: "คุณต้องการยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-22 tc-7",
                                    children: "การสร้างรายการนี้ใช่หรือไม่"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-center pt-4 mt-3  btn-group-control",
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/emps",
                                    className: "btn btn-st-3 mx-3 text-decoration-none",
                                    style: {
                                        width: "100px"
                                    },
                                    children: "ใช่"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 mx-3 ",
                                    style: {
                                        width: "100px"
                                    },
                                    onClick: props.onHide,
                                    children: "ไม่ใช่"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }));
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
var ImageProductUpload = function(_param) {
    var isUpdate = _param.isUpdate, setFormData = _param.setFormData, setModalObj = _param.setModalObj, modalObj = _param.modalObj, setIsLoading = _param.setIsLoading, setImgPath = _param.setImgPath, imgPath = _param.imgPath, view = _param.view, props = _object_without_properties(_param, [
        "isUpdate",
        "setFormData",
        "setModalObj",
        "modalObj",
        "setIsLoading",
        "setImgPath",
        "imgPath",
        "view"
    ]);
    var dispatch = useAppDispatch();
    // const [imgData, setImgData] = useState(false);
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var handlePreviewimage = function() {
        var _ref = _async_to_generator(function(e) {
            var formData;
            return _ts_generator(this, function(_state) {
                if (e.target.files[0]) {
                    formData = new FormData();
                    formData.append("upload_tmp_product", e.target.files[0]);
                    dispatch(uploadProduct(formData, {
                        modalObj: modalObj,
                        setModalObj: setModalObj
                    }));
                    setTextImg("image");
                }
                return [
                    2
                ];
            });
        });
        return function handlePreviewimage(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadProductReducer = useAppSelector(function(state) {
        return state.uploadProductReducer;
    });
    useEffect(function() {
        if (textImg == "image") {
            setIsLoading(uploadProductReducer.isFetching);
            if (uploadProductReducer.data) {
                console.log("uploadProductReducer", uploadProductReducer.data.data);
                setImgPath(uploadProductReducer.data.data);
                setTextImg("");
            }
        }
    }, [
        uploadProductReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "align-items-center mb-2 border-dashed-1 text-center",
        onClick: function(e) {
            return document.getElementById("fileProductUpload").click();
        },
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "file",
                name: "",
                className: "fileUpload hide-input",
                id: "fileProductUpload",
                accept: ".png, .jpg",
                onChange: function(e) {
                    handlePreviewimage(e);
                },
                disabled: view == "view" ? true : false
            }),
            imgPath ? /*#__PURE__*/ _jsx("img", {
                src: imgPath,
                style: {
                    width: 250
                }
            }) : /*#__PURE__*/ _jsxs("center", {
                className: "py-3",
                children: [
                    /*#__PURE__*/ _jsx(AddPhotoAlternateIcon, {
                        style: {
                            fontSize: 50,
                            color: "#B00412"
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-12",
                        style: {
                            color: "#B00412"
                        },
                        children: "ด้านหน้า"
                    })
                ]
            })
        ]
    });
};
var ImageGalleryUpload = function(_param) {
    var isUpdate = _param.isUpdate, galleryPath = _param.galleryPath, setGalleryPath = _param.setGalleryPath, setIsLoading = _param.setIsLoading, setModalObj = _param.setModalObj, modalObj = _param.modalObj, galleryDel = _param.galleryDel, setGalleryDel = _param.setGalleryDel, view = _param.view, disabled = _param.disabled, props = _object_without_properties(_param, [
        "isUpdate",
        "galleryPath",
        "setGalleryPath",
        "setIsLoading",
        "setModalObj",
        "modalObj",
        "galleryDel",
        "setGalleryDel",
        "view",
        "disabled"
    ]);
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), load = _useState1[0], setLoad = _useState1[1];
    console.log("galleryPath", galleryPath);
    var handlePreviewimage = function() {
        var _ref = _async_to_generator(function(e) {
            var files, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(e.target.files.length > 0)) return [
                            3,
                            8
                        ];
                        files = Array.from(e.target.files);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _loop = function() {
                            var file, formData, res;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        file = _step.value;
                                        formData = new FormData();
                                        formData.append("upload_tmp_product", file);
                                        return [
                                            4,
                                            dispatch(uploadProduct(formData, {
                                                modalObj: modalObj,
                                                setModalObj: setModalObj
                                            }))
                                        ];
                                    case 1:
                                        res = _state.sent();
                                        console.log("res", res);
                                        if (res === null || res === void 0 ? void 0 : res.data) {
                                            setGalleryPath(function(prev) {
                                                return _to_consumable_array(prev).concat([
                                                    {
                                                        id: nanoid(),
                                                        pd_pimage_name: res.data,
                                                        type: "create"
                                                    }
                                                ]);
                                            });
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _iterator = files[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        return [
                            5,
                            _ts_values(_loop())
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePreviewimage(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteDocument = function(removeId, item) {
        if (item.type == "update") {
            var del = {
                pd_pimage_id: item.pd_pimage_id
            };
            setGalleryDel(_to_consumable_array(galleryDel).concat([
                del
            ]));
        }
        setGalleryPath(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-xl-4 mt-3 ml-1",
        children: [
            galleryPath.map(function(item, index) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-2 col-md-3 mb-3",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: item.pd_pimage_name,
                                style: {
                                    width: 100,
                                    height: 100
                                }
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn  btn-delete-file-cross",
                                disabled: view == "view" ? true : false,
                                onClick: function() {
                                    return deleteDocument(item.id, item);
                                }
                            })
                        ]
                    })
                }, index);
            }),
            galleryPath.length < 8 && /*#__PURE__*/ _jsxs("div", {
                className: "col-xl-2 col-md-3 border-dashed-1",
                onClick: function(e) {
                    return document.getElementById("fileGalleryUpload").click();
                },
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "file",
                        multiple: true,
                        className: "fileUpload hide-input",
                        id: "fileGalleryUpload",
                        accept: ".png, .jpg",
                        onChange: handlePreviewimage,
                        disabled: view === "view"
                    }),
                    /*#__PURE__*/ _jsxs("center", {
                        children: [
                            /*#__PURE__*/ _jsx(AddPhotoAlternateIcon, {
                                style: {
                                    fontSize: 50,
                                    color: "#B00412"
                                }
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-12",
                                style: {
                                    color: "#B00412"
                                },
                                children: "เพิ่มรูปภาพ"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "fs-12",
                                style: {
                                    color: "#B00412"
                                },
                                children: [
                                    "(",
                                    galleryPath.length,
                                    "/8)"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var EvidenceDoc = function(_param) {
    var item = _param.item, index = _param.index, setFieldValue = _param.setFieldValue, values = _param.values, ondeleteDocument = _param.ondeleteDocument, setDocuments = _param.setDocuments, modalObj = _param.modalObj, setModalObj = _param.setModalObj, setIsLoading = _param.setIsLoading, evidenceType = _param.evidenceType, optionsProductFile = _param.optionsProductFile, disabled = _param.disabled, props = _object_without_properties(_param, [
        "item",
        "index",
        "setFieldValue",
        "values",
        "ondeleteDocument",
        "setDocuments",
        "modalObj",
        "setModalObj",
        "setIsLoading",
        "evidenceType",
        "optionsProductFile",
        "disabled"
    ]);
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var handlePreviewFile = function(e) {
        if (e.target.files[0]) {
            console.log("e.target.files[0]", e.target.files[0]);
            var formData = new FormData();
            formData.append("upload_tmp_product", e.target.files[0]);
            dispatch(uploadProduct(formData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setTextImg("doc");
        }
    };
    var uploadProductReducer = useAppSelector(function(state) {
        return state.uploadProductReducer;
    });
    useEffect(function() {
        if (textImg == "doc") {
            setIsLoading(uploadProductReducer.isFetching);
            if (uploadProductReducer.data) {
                console.log("uploadProductReducer", uploadProductReducer.data.data);
                setDocuments(function(prev) {
                    return prev.map(function(el) {
                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                            pd_pfile_name: uploadProductReducer.data.data
                        }) : el;
                    });
                });
                setTextImg("");
            }
        }
    }, [
        uploadProductReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "px-3",
        children: [
            index > 0 && /*#__PURE__*/ _jsx("hr", {
                className: "my-2",
                style: {
                    opacity: 0.1
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4 align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "fs-24 fw-bold tc-8",
                            children: [
                                index + 1,
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-xxl-3 col-xl-3 col-md-4 ",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-2 form-st-3 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "เอกสาร"
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        placeholder: "เลือกเอกสาร",
                                        name: "pd_pfile_typeid",
                                        onChange: function(e) {
                                            setDocuments(function(prev) {
                                                return prev.map(function(el) {
                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                        pd_pfile_typeid: e.value
                                                    }) : el;
                                                });
                                            });
                                        },
                                        className: "w-100 select-st-1",
                                        options: optionsProductFile,
                                        value: optionsProductFile.filter(function(d) {
                                            return d.value == item.pd_pfile_typeid;
                                        }),
                                        isDisabled: disabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                type: "file",
                                name: "",
                                className: "fileUpload hide-input",
                                id: "fileUpload".concat(item.id),
                                accept: ".pdf",
                                onChange: function(e) {
                                    handlePreviewFile(e);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                width: "280px"
                            },
                            children: item.pd_pfile_name != null ? /*#__PURE__*/ _jsx(Link, {
                                to: item.pd_pfile_name,
                                target: "_blank",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "docfile",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "icon pdf",
                                        children: item.pd_pfile_name.substring(68)
                                    })
                                })
                            }) : /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn  btn-upload-file",
                                disabled: disabled,
                                onClick: function(e) {
                                    return document.getElementById("fileUpload".concat(item.id)).click();
                                },
                                children: "อัปโหลดไฟล์"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn  btn-delete-file ",
                            disabled: disabled,
                            onClick: function(e) {
                                return ondeleteDocument(item.id, item);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto"
                    })
                ]
            }),
            " "
        ]
    });
};
export function ContinueModal(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID, Brandid = param.Brandid, Statusid = param.Statusid, Continueid = param.Continueid, filterText = param.filterText, Businessid = param.Businessid;
    var _modal_data, _modal_data1;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(1), 2), type = _useState[0], setType = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), id = _useState1[0], setId = _useState1[1];
    var updateStatusContinueReducer = useAppSelector(function(state) {
        return state.updateStatusContinueReducer;
    });
    useEffect(function() {
        if (modal.data == null) {
            setType(1);
            setId(0);
        }
        if (modal.data != null) {
            var vul = modal.data;
            setType(vul.status);
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        setIsLoading(updateStatusContinueReducer.isFetching);
        if (updateStatusContinueReducer.data && !updateStatusContinueReducer.isError) {
            setTextsuccess("แก้ไขสถานะContinueสำเร็จ");
            setModalsuccess(true);
            dispatch(datalistProduct({
                brand: Brandid,
                status: Statusid,
                continueStatus: Continueid,
                productname: filterText,
                businessid: parseInt(Businessid)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setType(1);
            setId(0);
        }
    }, [
        updateStatusContinueReducer
    ]);
    var onClickModel = function() {
        var data = {
            productid: id,
            statuscontinue: type == 1 ? 2 : 1
        };
        dispatch(updateStatusContinue(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการเปลี่ยนสถานะข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 mt-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.nameth
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-20 !text-[#CCC] mb-6",
                    children: (_modal_data1 = modal.data) === null || _modal_data1 === void 0 ? void 0 : _modal_data1.nameen
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
